export const joinBroadcastOptions = [
  // { id: 'host', text: 'Ask to host this broadcast' },
  // { id: 'facebook', text: 'View Facebook comments' },
  { id: 'remove', text: 'Remove me from invite list' },
];

export const myBroadcastOptions = [
  { id: 'rename', text: 'Edit title' },
  // { id: 'transfer', text: 'Transfer to another broadcaster...' },
  // { id: 'move', text: 'Move to another channel...' },
  // { id: 'facebook', text: 'View Facebook comments' },
  { id: 'close', text: 'Close broadcast' },
];

export const guestBroadcastOptions = [{ id: 'remove', text: 'Remove me from guest list' }];
